var preciosAdminService = angular.module('preciosAdmin');

preciosAdminService.factory('preciosAdminService', ['$http', '$q', '__env', function preciosAdminService($http, $q, __env) {
        var serviceUrl = __env.apiUrl;
        var categoriasUrl = 'categorias';
        var rolesUrl = 'roles';

    function getPrecios() {
        return $http.get(serviceUrl + categoriasUrl + '/precios');
        }

    function getPrecio(id) {
        return $http.get(serviceUrl + categoriasUrl + '/precios/' + id);
        }

    function put(descripcion, precio) {
        return $http({
            method: 'put',
            url: serviceUrl + categoriasUrl + '/editar/precios/' + id,
            params:
                {
                    'descripcion': descripcion,
                    'precio': precio
                }
            });
        }

    function post(descripcion, precio) {
            //return $http.post(serviceUrl + usuariosUrl + '/registrar/' + idRolUsuario, usuario);
            return $http({
                method: 'post',
                url: serviceUrl + categoriasUrl + '/registrar/precios',
                params:
                {
                    'descripcion': descripcion,
                    'precio': precio
                }

            });
        }

        function obtenerPrimerErrorModelState(response) {
            var errores = [];
            for (var key in response.ModelState) {
                for (var i = 0; i < response.ModelState[key].length; i++) {
                    errores.push(response.ModelState[key][i]);
                }
            }
            return errores[0];
    }

    function eliminarPrecios(preciosEliminar) {
        return $http.post(serviceUrl + categoriasUrl + '/eliminarPrecios/' + preciosEliminar, { headers: { 'Content-Type': 'application/json' } }).catch(function (response) {
                alert('Error');
            });
        }



        return {
            getPrecios: getPrecios,
            getPrecio: getPrecio,
            put: put,
            post: post,
            obtenerPrimerErrorModelState: obtenerPrimerErrorModelState,
            eliminarPrecios: eliminarPrecios,
        }

    }]);